<template>
  <section class="contact">
    <div class="contact-tx">
      <h2>
        御葬儀についてのご心配、ご不安
        <br />
        事前のご相談もお気軽にご連絡ください
      </h2>
      <p>
        もしものとき何をしたらいいかわからない…
        <br />
        ご心配なことがありましたら、すべてお気軽にご相談くださいませ。
      </p>
      <router-link class="contact-btn" to="contact">ご相談はこちら</router-link>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.contact {
  padding: 80px $h-gap;
  background-image: url("@/assets/images/bg-contact.jpg");
  background-position: center;
  background-size: cover;
  text-align: center;
  .contact-tx {
    max-width: 760px;
    margin: 0 auto;
    h2 {
      font-size: 2rem;
      line-height: 1.5;
      margin-bottom: 2rem;
      @include tb {
        font-size: 1.25rem;
      }
    }
    p {
      font-size: 1rem;
      margin-bottom: 2rem;
    }
    .contact-btn {
      @include contact-btn;
    }
  }
}
</style>
